import React, { useEffect, useState } from 'react';
import BlogInfo from '../BlogInfo/BlogInfo';
import demoData from '../../demoData/blogData.json';
import './Blogs.css';

const Blogs = () => {
    const [blogs, setBlogs] = useState([]);

    useEffect(() => {
        setBlogs(demoData);
    }, [])
    
    return (
        <div className="container spacing-blog" style={{overflowX: 'hidden', overflowY: 'hidden'}}>
            <div className="project-section">
                <h1 className="text-center mb-4 blog-pad">My Blogs</h1>
                <div className="card-group row mb-5 pb-5" >
                    {
                        blogs.map(blog => <BlogInfo blog={blog} key={blog.id}></BlogInfo>)
                    }
                </div>
            </div>
        </div>
    );
};

export default Blogs;